import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["variants"];
import { internal_serializeStyles } from '@mui/styled-engine';
export default function preprocessStyles(input) {
  var variants = input.variants,
      style = _objectWithoutProperties(input, _excluded);

  var result = {
    variants: variants,
    style: internal_serializeStyles(style),
    isProcessed: true
  }; // Not supported on styled-components

  if (result.style === style) {
    return result;
  }

  if (variants) {
    variants.forEach(function (variant) {
      if (typeof variant.style !== 'function') {
        variant.style = internal_serializeStyles(variant.style);
      }
    });
  }

  return result;
}